export const environment = {
    production: true,
    facebookAppId:'2412041408936539',
    FbVersion: 'v16.0',
    pageId:'106584975435576',
    project:'thetucsongemshow',
    
    /* LIVE SERVER URLS ACCORDING TO DOMAIN */
    
    serverUrl:'https://api.thetucsongemshow.live',  // for the tucsongemshow live server url
    // serverUrl:'https://apistaging.thetucsongemshow.live',    // for staging server url
    // serverUrl:'https://gemmonkeyapi.thetucsongemshow.live/',    // for gemmonkey server url
  
    // serverUrl: 'https://sunwestsilver.thetucsongemshow.live/', // For Sunwest silver server url
};